export default __webpack_public_path__ + "static/extra-curricular-logo-ea09db45afe5012caf75b196b221159a.png";